export default "__VITE_ASSET__tJCWkgsU__"